import { Resolvable } from "@lernetz/ts-lib/src/components/Resolve";
import Model from '@lernetz/ts-lib/src/core/model/Model';

import {ImageStep} from './ImageStep';
import {StepByStep} from './StepByStep';

export class StepTheme extends Model implements Resolvable{

    public constructor(json: object) {
        super({
            steps:[],
            title: '',
            index: null,
            currentStep:null,
            currentIndex:null,
            nofullscreen:true,
            ...json
        });

        this.currentStep = this.steps[0];
    }

    public index:number;
    public readonly steps:ImageStep[];
    public readonly title:string;
    public currentStep:ImageStep;
    public currentIndex:number = 1;
    public nofullscreen:boolean
    public stepbystep:StepByStep

    public getViewName(): string {
        return 'StepTheme';
    }

    public toPreviousStep(){
        if( this.currentIndex == 1 ) return;
        this.currentIndex--;
        this.currentStep = this.steps[this.currentIndex - 1];
    }
    public toNextStep(){
        if( this.currentIndex == this.steps.length ) return;
        this.currentIndex++;
        this.currentStep = this.steps[this.currentIndex - 1];
    }

    public toggleFullscreen(){
        this.nofullscreen = !this.nofullscreen;
    }

}